import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted } from "@/BaseComponent";
    interface Props {
        spinnerSize?: number; // 스피너 크기
        thickness?: number; // 스피너 굵기
        borderColor?: string; // 스피너 배경 색상
        isFullPage?: boolean; // 전체화면 사용 여부
        color?: string; // 스피너 내부 색상
        speed?: number;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'spinner',
  props: {
    spinnerSize: { default: 48 },
    thickness: { default: 5 },
    borderColor: { default: "" },
    isFullPage: { type: Boolean },
    color: { default: "" },
    speed: { default: 0.8 }
  },
  setup(__props: any) {

    const props = __props;

    onMounted(() => {
        if (props.isFullPage) document.body.style.overflow = "hidden";
    });

    onUnmounted(() => {
        if (props.isFullPage) document.body.style.overflow = "";
    });

    const spinnerColor = computed(() => {
        if (!props.color) return "#31A6D8"; // 기본 값
        const s = new Option().style;
        s.color = props.color;

        return s.color ? s.color : "#31A6D8";
    });

    const lineColor = computed(() => {
        if (!props.borderColor) return "#e2e2e2"; // 기본 값
        const s = new Option().style;
        s.color = props.borderColor;

        return s.color ? s.color : "#e2e2e2";
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spinner_wrap", { full: props.isFullPage }])
  }, [
    _createElementVNode("div", {
      class: "spinner",
      style: _normalizeStyle({
                width: `${props.isFullPage ? props.spinnerSize * 1.5 : props.spinnerSize}px`,
                height: `${props.isFullPage ? props.spinnerSize * 1.5 : props.spinnerSize}px`,
                border: `${props.thickness}px solid ${_unref(lineColor)}`,
                borderBottomColor: _unref(spinnerColor),
                animationDuration: `${props.speed}s`,
            })
    }, null, 4)
  ], 2))
}
}

})